import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["transitionEnd", "transition"];
import { useContext } from 'react';
import { isAnimationControls } from '../../animation/utils/is-animation-controls.mjs';
import { PresenceContext } from '../../context/PresenceContext.mjs';
import { resolveVariantFromProps } from '../../render/utils/resolve-variants.mjs';
import { useConstant } from '../../utils/use-constant.mjs';
import { resolveMotionValue } from '../../value/utils/resolve-motion-value.mjs';
import { MotionContext } from '../../context/MotionContext/index.mjs';
import { isControllingVariants, isVariantNode } from '../../render/utils/is-controlling-variants.mjs';
import { getWillChangeName } from '../../value/use-will-change/get-will-change-name.mjs';
import { addUniqueItem } from '../../utils/array.mjs';
function makeState(_ref, props, context, presenceContext, isStatic) {
  var _ref$applyWillChange = _ref.applyWillChange,
    applyWillChange = _ref$applyWillChange === void 0 ? false : _ref$applyWillChange,
    scrapeMotionValuesFromProps = _ref.scrapeMotionValuesFromProps,
    createRenderState = _ref.createRenderState,
    onMount = _ref.onMount;
  var state = {
    latestValues: makeLatestValues(props, context, presenceContext, isStatic ? false : applyWillChange, scrapeMotionValuesFromProps),
    renderState: createRenderState()
  };
  if (onMount) {
    state.mount = function (instance) {
      return onMount(props, instance, state);
    };
  }
  return state;
}
var makeUseVisualState = function makeUseVisualState(config) {
  return function (props, isStatic) {
    var context = useContext(MotionContext);
    var presenceContext = useContext(PresenceContext);
    var make = function make() {
      return makeState(config, props, context, presenceContext, isStatic);
    };
    return isStatic ? make() : useConstant(make);
  };
};
function addWillChange(willChange, name) {
  var memberName = getWillChangeName(name);
  if (memberName) {
    addUniqueItem(willChange, memberName);
  }
}
function forEachDefinition(props, definition, callback) {
  var list = Array.isArray(definition) ? definition : [definition];
  for (var i = 0; i < list.length; i++) {
    var resolved = resolveVariantFromProps(props, list[i]);
    if (resolved) {
      var transitionEnd = resolved.transitionEnd,
        transition = resolved.transition,
        target = _objectWithoutProperties(resolved, _excluded);
      callback(target, transitionEnd);
    }
  }
}
function makeLatestValues(props, context, presenceContext, shouldApplyWillChange, scrapeMotionValues) {
  var _a;
  var values = {};
  var willChange = [];
  var applyWillChange = shouldApplyWillChange && ((_a = props.style) === null || _a === void 0 ? void 0 : _a.willChange) === undefined;
  var motionValues = scrapeMotionValues(props, {});
  for (var key in motionValues) {
    values[key] = resolveMotionValue(motionValues[key]);
  }
  var initial = props.initial,
    animate = props.animate;
  var isControllingVariants$1 = isControllingVariants(props);
  var isVariantNode$1 = isVariantNode(props);
  if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
    if (initial === undefined) initial = context.initial;
    if (animate === undefined) animate = context.animate;
  }
  var isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
  isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
  var variantToSet = isInitialAnimationBlocked ? animate : initial;
  if (variantToSet && typeof variantToSet !== "boolean" && !isAnimationControls(variantToSet)) {
    forEachDefinition(props, variantToSet, function (target, transitionEnd) {
      for (var _key in target) {
        var valueTarget = target[_key];
        if (Array.isArray(valueTarget)) {
          /**
           * Take final keyframe if the initial animation is blocked because
           * we want to initialise at the end of that blocked animation.
           */
          var index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
          valueTarget = valueTarget[index];
        }
        if (valueTarget !== null) {
          values[_key] = valueTarget;
        }
      }
      for (var _key2 in transitionEnd) {
        values[_key2] = transitionEnd[_key2];
      }
    });
  }
  // Add animating values to will-change
  if (applyWillChange) {
    if (animate && initial !== false && !isAnimationControls(animate)) {
      forEachDefinition(props, animate, function (target) {
        for (var _key3 in target) {
          addWillChange(willChange, _key3);
        }
      });
    }
    if (willChange.length) {
      values.willChange = willChange.join(",");
    }
  }
  return values;
}
export { makeUseVisualState };